
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.861.861 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-8.08-5.634l6.325 6.324h-6.325V2.978zm6.604 28.292H6.009V2.73h13.649v7.438c0 .478.387.865.865.865h7.469V31.27z"}}),_c('path',{attrs:{"d":"M9.749 10.6h6.262a.432.432 0 000-.864H9.749a.432.432 0 000 .864zm-.432 3.468c0 .239.194.432.432.432h14.5a.432.432 0 000-.864h-14.5a.433.433 0 00-.432.432zm2.215 5.874H9.037v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.42-.378-.999-.567-1.739-.567zm1.096 3.048c-.254.225-.62.338-1.097.338H9.929v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968-.001.426-.128.751-.382.975zm4.905-3.048h-2.494v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.42-.378-.999-.567-1.74-.567zm1.097 3.048c-.254.225-.62.338-1.097.338H15.93v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968 0 .426-.128.751-.381.975zm1.853-2.319h2.169v6.035h.887v-6.035h2.175v-.73h-5.231"}})])])
          )
        }
      }
    